
import React from "react";
import { cn } from "@/lib/utils";
import ReactMarkdown from 'react-markdown';

interface MessageProps {
  message: {
    id: string;
    role: "user" | "assistant" | "system";
    content: string;
    imageUrl?: string;
    audioUrl?: string;
    analysisMode?: "medical" | "general";
  };
  voiceOnlyMode?: boolean;
}

export const Message: React.FC<MessageProps> = ({ message, voiceOnlyMode }) => {
  const isUser = message.role === "user";
  
  // Replace any instances of "Famagid" with "Medicace" in the message content
  const processedContent = message.content.replace(/Famagid/gi, "Medicace");
  
  return (
    <div className={cn(
      "flex w-full",
      isUser ? "justify-end" : "justify-start"
    )}>
      <div className={cn(
        "rounded-lg px-4 py-3 max-w-[85%]",
        isUser ? 
          "bg-primary text-primary-foreground" : 
          "bg-secondary/50 border border-primary/20 backdrop-blur-sm"
      )}>
        {message.imageUrl && (
          <div className="mb-3">
            <img 
              src={message.imageUrl} 
              alt="User uploaded"
              className="rounded-md max-h-60 max-w-full object-contain"
            />
          </div>
        )}
        
        <div className="prose prose-sm dark:prose-invert">
          <ReactMarkdown>
            {processedContent}
          </ReactMarkdown>
        </div>
        
        {message.audioUrl && !voiceOnlyMode && (
          <div className="mt-2">
            <audio src={message.audioUrl} controls className="w-full max-w-[300px]" />
          </div>
        )}
      </div>
    </div>
  );
};
